import valent from '../image/Valentpath.png';
import jstar from '../image/jstar.png';
import casa from '../image/casa.png';
import real from '../image/real.png';
import debbie from '../image/debbie.png';
import holmes from '../image/Holmes.png';
import child from '../image/child.png';
import tanduri from '../image/Tanduri.png';
import card from '../image/card.png';
import enyxa from '../image/enyxa.png';
import lenses from '../image/Lenses.png';
import elevation from '../image/Wpelevation.png';
import family from '../image/gearing.png';
import british from '../image/bristi.png';
import cbeaux from '../image/cbeuax.png';
import rotimatic from '../image/rotimatic.png';
import vilros from '../image/vilros.png';
import schema from '../image/schema.png';
import supa from '../image/supadezign.png';
import bazer from '../image/fashion.jpg';
import hotel from '../image/hotel.png';
import member from '../image/blog.png';

const fakeProjectData = [
  {
    id: 1,img: valent, url: 'https://valentpath.com/',
    autor: 'Najir Ahmed', Date:  '06/10/2000', client: 'Borderless-Assistant-Project',
    skills: [ { name: 'Wordpress' }, { name: 'PHP' }],
  },
  {
    id: 2,img: jstar, url: 'https://www.jstar-research.com/',
    autor: 'Najir Ahmed', Date:  '11/16/2000', client: 'Borderless-Assistant-Project',
    skills: [ { name: 'Wordpress' }, { name: 'PHP' }],
  },
  {
    id: 3,img: casa, url: 'https://businessintuitive.net/',
    autor: 'Najir Ahmed', Date:  '11/28/2020', client: 'Borderless-Assistant-Project',
    skills: [ { name: 'Wordpress' }, { name: 'PHP' }],
  },
  {
    id: 4,img: real, url: 'https://vorofy.borderless-assistantsbd.com/',
    autor: 'Najir Ahmed', Date:  '12/19/2020', client: 'Borderless-Assistant-Project',
    skills: [ { name: 'Wordpress' }, { name: 'PHP' }],
  },
  {
    id: 1,img: debbie, url: 'https://businessintuitive.net/',
    autor: 'Najir Ahmed', Date:  '12/06/2000', client: 'Borderless-Assistant-Project',
    skills: [ { name: 'Wordpress' }, { name: 'PHP' }],
  },
  {
    id: 5,img: holmes, url: 'https://www.holmescay.com/',
    autor: 'Najir Ahmed', Date:  '10/12/2000', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 6,img: child, url: 'https://freechildcaregroup.com/',
    autor: 'Najir Ahmed', Date:  '11/14/2020', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 7,img: tanduri, url: 'https://borderless-assistantsbd.com/hestia/',
    autor: 'Najir Ahmed', Date:  '11/21/2020', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 8,img: card, url: 'https://www.cardpop.co.uk/',
    autor: 'Najir Ahmed', Date:  '11/14/2000', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 9,img: enyxa, url: 'https://enyxa.hu/',
    autor: 'Najir Ahmed', Date:  '09/10/2020', client: 'Borderless-Assistant-Project',
    skills: [ { name: 'Wordpress' }, { name: 'PHP' }],
  },
  {
    id: 10,img: lenses, url: 'https://www.mrlenses.com/',
    autor: 'Najir Ahmed', Date:  '09/16/2000', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 11,img: elevation, url: 'https://www.wpelevation.com/',
    autor: 'Najir Ahmed', Date:  '11/21/2020', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 1,img: family, url: 'https://grmfamilylaw.com/',
    autor: 'Najir Ahmed', Date:  '11/8/2000', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 12,img: british, url: 'https://britishknights.com/',
    autor: 'Najir Ahmed', Date:  '11/21/2000', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 13,img: cbeaux, url: 'https://cbeaux.com/',
    autor: 'Najir Ahmed', Date:  '01/12/2001', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 14,img: rotimatic, url: 'https://rotimatic.com/',
    autor: 'Najir Ahmed', Date:  '01/16/2001', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 15,img: vilros, url: 'https://vilros.com/',
    autor: 'Ariful Islam', Date:  '02/06/2001', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 16,img: schema, url: 'https://www.schema-studio.ch',
    autor: 'Ariful Islam', Date:  '20/01/2001', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 17,img: supa, url: 'https://www.supadezign.com',
    autor: 'Ariful Islam', Date:  '09/10/2000', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 19,img: hotel, url: 'https://hotel.borderless-assistantsbd.com',
    autor: 'Uddipan Chakma', Date:  '01/16/2000', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  {
    id: 20,img: member, url: 'https://membership.borderless-assistantsbd.com/',
    autor: 'Mohammad Ali Ashraf Khan', Date:  '11/16/2000', client: 'Borderless-Assistant-Project',
    skill1:'Wordpress' , skill2: 'PHP',
  },
  
];

export default fakeProjectData;
